export default {
    patentReview: {
        documentPane: {
            page: '{current} / {total} ページ',
            previousPage: '前のページ',
            nextPage: '次のページ',
            'document': 'レビュー対象ファイル',
            'readOnly': '読み取り専用',
            'localFile': 'ローカルプレビュー',
            'original': '元の文書',
            'text': '抽出テキスト',
            'textHint': '抽出テキストは照合と位置確認用です。元の書式は保持されません。',
            'zoomIn': '拡大',
            'zoomOut': '縮小',
            'loading': '文書を読み込み中…',
            'unsupported': 'この形式の原本プレビューには対応していません。抽出テキストをご覧ください。Word は DOCX に対応しています。',
            'failed': '元のファイルを読み込めませんでした。再試行するか抽出テキストをご覧ください。',
            'noFile': 'プレビュー可能な原本がありません。ローカルの Word / PDF を選択できます。ブラウザー内でのみ表示し、アップロードやタスクのファイル変更は行いません。',
            'retry': '再試行',
            'unresolved': '正確な位置を特定できません。右側の指摘と原文を照合してください。',
            'missingInsertion': '不足内容をここに追加してください',
            'empty': '抽出内容はまだありません',
        },
        results: {
            'results': 'レビュー結果',
            'sort': '並び替え',
            'importance': '重要度順',
            'document': '文書内の順序',
            'figureOrder': '図面内の順序',
            'passed': '適合',
            'failed': '不適合',
            'manual': '要確認',
            'ignore': '無視',
            'confirm': '確認',
            'ignored': '無視済み',
            'confirmed': '確認済み',
            'summary': 'レビュー結果の集計',
            'ruleName': 'ルール名',
            'unnamedRule': '名称未設定のルール',
            'expand': '展開',
            'collapse': '折りたたむ',
            'status': 'ステータス',
            'rule': 'チェックルール',
            'reason': '不適合の理由',
            'explanation': '結果の説明',
            'suggestion': '修正案',
            'location': '該当箇所',
            'system': 'システムルール',
            'custom': 'カスタムルール',
            'ruleUnavailable': 'ルール原文なし',
            'locationUnavailable': '原文の位置情報なし',
            'orderHint': '解析済みの章と原文位置で並べます。位置情報のない項目は章順を保持します。',
            'figureOrderHint': '選択中の図面内の位置で並べます。位置情報のない項目はチェック順を保持します。',
        },
        figurePane: {
            combinedReview: '図面レビュー', abstractDrawing: '要約図',
            workspace: '図面照合ワークスペース', readOnly: '読み取り専用', recognizedCount: '{count} 件の図面を認識',
            figure_overview: '図面ごとのレビュー', figure_completeness: '図面の完全性', figure_compliance: '図面形式', figure_consistency: '図面と本文の整合性', abstract_drawing: '要約図',
            matrixTitle: '図面ごとのレビュー状態', drawing: '図面', presenceCheck: '欠落なし', visualCheck: '図面内の適合性', claimsCheck: '請求項との整合性', specificationCheck: '明細書との整合性',
            drawingNavigator: '図面ナビゲーション', drawingTotal: '全 {count} 件', collapseNavigator: '折りたたむ', expandNavigator: '展開', drawingRange: '{start}～{end}件目',
            presenceShort: '存在', visualShort: '図面内', claimsShort: '請求項', specificationShort: '明細書',
            checkStatus_pass: '合格', checkStatus_fail: '不合格', checkStatus_manual: '要確認', checkStatus_pending: '未検査', numberNeedsConfirmation: '図番号要確認',
            previousDrawing: '前の図面', nextDrawing: '次の図面', drawingPosition: '{current} / {total}件目', drawingReviewTitle: '{drawing}のレビュー',
            missingFigure: '図面が不足', missingFigureHint: '本文には図{number}がありますが、対応する画像が認識されませんでした。', abstractCandidates: '要約図の候補',
            recognitionUnavailable: '図面認識結果がありません', recognitionUnavailableHint: '図面の有無を確認できないため、この工程を適合とは判定しません。',
            expectedFigures: '本文から想定される図面', actualFigures: '実際に認識した図面', figureNo: '図{number}', unknownFigure: '図番号不明・{number}件目',
            noFigureNumbers: '画像は認識されましたが、照合できる図番号がありません。', noFigures: '図面が認識されませんでした', noFiguresHint: '図面が必要な出願か確認し、必要に応じてファイルを追加してください。',
            notFound: '見つかりません', unknownCount: 'ほかに {count} 件の画像で図番号を特定できません', inventoryBasis: '想定図面の根拠', noDrawingsDescription: '図面の説明が認識されていないため、想定一覧が不完全な可能性があります。',
            previewPending: '現在のAPIは単一画像プレビューを提供していません', noDescription: '図面の認識説明はありません', referenceSigns: '認識した符号', noReferenceSigns: '符号は認識されませんでした',
            drawingsDescription: '図面の簡単な説明', relatedFullText: '関連全文を表示', noRelatedText: '照合できる本文がありません', abstractText: '要約本文', noAbstract: '要約本文が認識されませんでした',
            abstractCandidateHint: '現版では候補図面と要約を並べて表示します。要約図の選択はレビュー結果で確認してください。',
            confidence_high: '図番号の信頼度：高', confidence_medium: '図番号はモデル推定', confidence_low: '図番号の確認が必要',
            source_caption_regex: '原文の図番号から取得', source_vision_match: '図文照合から取得', source_unknown: '図番号の出典不明',
        },
        workflow: {
            incompleteFileTitle: 'ファイルの内容が不完全です',
            skipMissingNotice: '次の項目のチェックをスキップします：{sections}。完全なレビューには不足ファイルを追加してください。',
            fileChecklist: 'ファイル内容チェックリスト',
            notRecognized: '未検出',
            missingSection: '{section}が検出されていないため、以降は{section}をチェックしません。',
            unconfirmedSection: '{section}の検出状況は未確認です。原文を確認し、必要に応じてファイルを追加してください。',
            supplementSection: 'ファイルを補充：{section}',
            replaceSupplement: 'ファイルを変更',
            supplementPending: '送信待ち · このファイルは現在のページにのみ保持され、このレビューにはまだ追加されていません。',
            invalidSupplement: '空でない Word、PDF、TXT または画像ファイルを選択してください。',
            reviewCount: '{count} 件の要確認記録',
            noConclusion: '総合結論はまだありません。各部分の結果をご確認ください。',
            claimsMaterial: '請求項',
            specificationMaterial: '明細書',
            'detection': 'ファイル確認',
            'claims': '請求項レビュー',
            'specification': '明細書レビュー',
            'figures': '図面レビュー',
            'report': 'レビュー結果',
            'title': '発明の名称',
            'technical_field': '技術分野',
            'background': '背景技術',
            'summary': '発明の概要',
            'detailed_description': '実施形態',
            'abstract': '要約',
            'drawings': '図面',
            'drawings_description': '図面の説明',
            'figure_overview': '図面ごとのレビュー',
            'figure_completeness': '図面の完全性',
            'figure_compliance': '図面形式',
            'figure_consistency': '図面と本文の整合性',
            'abstract_drawing': '要約図',
            'unclassified': '複数部分／未分類',
            'all': 'すべての結果',
            'waiting': '結果待ち',
            'partial': '一部の結果を表示可能',
            'available': '結果を表示可能',
            'failed': '処理中断',
            'source': '原文と資料',
            'detected': '識別済み',
            'unconfirmed': '要確認',
            'detecting': '識別中',
            'figureFound': '図面を {count} 件識別しました。適用性の確認が必要です',
            'figureEmpty': '図面が識別されませんでした。必要かどうか確認してください',
            'figureUnknown': '図面の識別結果がありません。適用外とは判断できません',
            'optional': '任意の資料です。出願書類レビューの開始を妨げません',
            'disclosure': '技術開示資料',
            'supplement': '資料を補完',
            'supplementHint': '現在のタスクには資料を追加できません。ホームに戻り、資料一式をアップロードして新しいタスクを作成してください。',
            'newTask': 'ホームに戻ってアップロード',
            'close': '閉じる',
            'reviewHint': '結果は書類の部分ごとに表示されます。一部の結果のみ表示されている場合、追加の指摘が届くことがあります。',
            'scopeHint': '対象部分を特定できない結果を以下に表示しています。併せて確認してください。',
            'empty': 'この範囲の検査記録はまだありません。検査合格を意味するものではありません。',
            'noSource': '表示できる原文がありません。ファイル確認の結果をご覧ください。',
            'sourceWhole': '明細書の全文を表示しています。各部分の位置は指摘箇所を確認してください。',
            'confirmDetection': '確認',
            'locate': '原文の位置を表示',
            'basis': '判断根拠',
            'suggestion': '修正提案',
            'boundary': '適用範囲',
            'notAssessed': '未判定',
            'pass': '合格',
            'issue': '要確認',
            'retry': '結果を再読み込み',
            'loadFailed': '結果を読み込めませんでした。再試行してください。',
            'detectionHint': '各部分の不足や読み取り可否を確認します。図面の適用性と完全性も対象です。内容の識別は検査合格を意味しません。',
            'pendingApplicability': '適用性の確認待ち',
            'export': 'レポートを出力',
            'reportPending': 'レポートはまだ生成されていません。各部分の取得済み結果を確認できます。',
        },
        entry: {
            materials: 'レビュー資料',
            applicationReview: '特許出願',
            description: 'レビュー対象の出願書類をアップロードし、必要に応じて参考資料を追加してください。',
            required: '必須',
            optional: '任意',
            choose: 'ファイルを選択',
            replace: 'ファイルを変更',
            remove: '{name} を削除',
            targetLabel: '出願書類',
            targetHint: '完全な特許出願原稿を1件アップロード。Word、PDF に対応し、ドラッグ＆ドロップも可能です。',
            supportingLabel: 'その他の技術資料',
            supportingHint: '技術的な整合性を確認するための資料を複数アップロードできます。Word、PDF、TXT、JPG、PNG に対応。',
            disclosureLabel: '技術開示資料',
            disclosureHint: '出願原稿との技術内容の整合性を確認 · Word / PDF / TXT',
            otherLabel: 'その他の資料',
            otherHint: '現在は図面資料に対応 · PDF / JPG / PNG',
            unsupportedFormat: 'この資料では対応していないファイル形式です。',
            tooManyFiles: '資料は合計10ファイルまで選択できます。',
            oneTarget: '完全な出願書類を1ファイル選択してください。',
            fileCount: '{count}/10 ファイルを選択済み',
            start: 'レビュー開始',
            submitting: '送信中…',
            rules: 'ルールライブラリ',
            selectedLibraries: '{office} · {count} ライブラリ',
            libraryHint: 'システムライブラリから特許庁が決まります。同じ特許庁のカスタムライブラリを追加できます。',
            taskCreated: 'レビュータスクを作成しました',
            ruleDialog: 'ルールライブラリを選択',
            ruleScopeHint: 'システムライブラリを1つ選択し、同じ特許庁のカスタムライブラリを追加できます。変更すると他の特許庁の選択は解除されます。',
            selectionRequired: '有効なシステムライブラリと同じ特許庁のカスタムライブラリを選択してください。',
            libraryLoadFailed: '読み込みに失敗しました。閉じて再試行してください。',
        },
        list: {
            title: '審査タスク',
            empty: '審査タスクはまだありません',
            emptyHint: '特許出願原稿をアップロードして形式審査を開始',
            rules: '件のルール',
            tabTasks: 'タスク一覧',
            tabRules: 'ルールライブラリ',
        },
        status: {
            pending: '待機中',
            running: '実行中',
            completed: '完了',
            failed: '失敗',
        },
        steps: {
            '1_parsing': 'ファイル解析',
            '2_extracting': '四要素抽出',
            '3_figure_analysis': '図面分析',
            '4_formal_check': '形式審査',
            '5_finalizing': '最終報告',
        },
        stepStatus: {
            done: '完了',
            running: '実行中',
            failed: '失敗',
            pending: '待機中',
        },
        upload: {
            customRulesSection: {
                dialogTitle: 'ルールライブラリ',
                searchPlaceholder: 'ルールライブラリ名を検索',
                customGroup: 'カスタムルールライブラリ',
                newGroup: '今回の新規アップロード',
                uploadButton: 'ルールをアップロード',
                uploadFormats: '.docx / .pdf / .pptx に対応',
                confirm: '選択を確認',
                confirmSelection: '確認',
                empty: 'ルールライブラリはまだありません。「ルールをアップロード」で追加してください',
                rulesEmpty: 'このルールライブラリからルールは抽出されませんでした',
                loadFailed: 'ルールライブラリ一覧の読み込みに失敗しました。再試行してください',
                uploadFailed: 'ルールファイルのアップロードに失敗しました。再試行してください',
                tableIndex: '番号',
                tableSection: 'レビュー項目',
                tableIssueDesc: '問題の説明',
            },
            patentType: {
                label: '特許種別',
                invention: '発明',
                utility: '実用新案',
            },
            cancel: 'キャンセル',
        },
        detail: {
            backToList: '一覧に戻る',
            taskHeader: {
                entry: '核稿審査',
                projectPackage: '特許審査プロジェクトパッケージ',
                unnamedTask: '無題のタスク',
                progressTitle: '審査進捗',
                autoRun: '自動実行',
                exportReport: 'レポートを出力',
                exportNotReady: '審査完了後に出力できます',
                finalizingCardSubtitle: '総合結論',
                stepsExecutedCaption: '3つのプロセスが実行済み',
                parsingCaption: '解析中',
                issueCountSuffix: '{count} 件の問題',
            },
            materials: {
                mainFileTag: '特許出願書類',
                figureTag: '図面',
                disclosureTag: '開示資料',
                attachmentTag: '添付ファイル',
            },
            parsing: {
                fileName: 'ファイル名',
                fileNamePending: 'メインファイルを識別中…',
                hint: 'アップロードされたファイルを解析しています…',
                inspectionSummary: '{located}/{total} セクションを特定',
                characterCount: '{count} 文字',
                locate: '位置を表示',
                missing: '内容を検出できません',
                documentType: {
                    patent_application: '特許出願書類',
                    disclosure: '技術開示資料',
                    office_action: '拒絶理由通知',
                    unknown: '文書種別の確認が必要',
                },
            },
            extracting: {
                title: '発明の名称',
                technical_field: '技術分野',
                background: '背景技術',
                summary: '発明の概要',
                drawings_description: '図面の説明',
                detailed_description: '詳細な説明',
                abstract: '要約',
                claims: '特許請求の範囲',
                specification: '明細書',
                figures: '図面',
                expand: '展開',
                collapse: '折りたたむ',
                empty: '内容がありません',
            },
            check: {
                pass: '合格',
                passCollapsed: '合格（{count} 件）',
                filterAll: 'すべて',
                filterInfo: '情報',
                filterWarning: '警告',
                filterError: 'エラー',
                filterCritical: '重大',
                location: '位置',
                suggestion: '修正案',
                guidelineSource: '根拠出典',
                empty: '形式審査の問題はありません',
                summaryPattern: '位置を特定できる形式または企業規範の問題を {count} 件検出しました',
                statTitle: '形式問題を{count}件検出しました。うち公式ルール違反{officialCount}件、企業ルール違反{customCount}件。',
                statFormalIssues: '形式問題',
                statOfficialViolations: '公式ルール違反',
                statCustomViolations: '企業ルール違反',
                summaryTitle: '形式審査·まとめ',
                summaryError: '{count}件のエラー',
                summaryWarning: '{count}件の規範違反',
                summaryRequireConfirm: '{count}件の人工確認が必要',
                summaryStats: '全{total}個ルール·{error}件·{warning}件·{requireConfirm}件·{pass}件合格',
                systemRules: 'システムルール',
                customRules: '企業ルール',
                legendPass: '合格',
                legendFail: '不合格',
                legendPending: '人工確認が必要',
                summaryAllPassed: 'すべて合格',
                coverageTitle: 'ルールカバレッジ',
                coverageSource: 'ルールソース',
                coverageTotal: 'ルール数',
                coverageFail: '不合格',
                coverageVerify: '要確認',
                coveragePending: '要再検証',
                coveragePassed: '合格',
            },
            table: {
                tabIssues: '問題特定表',
                tabCoverage: 'チェック網羅',
                sourceOfficial: '公式ルール',
                sourceCustom: '企業ルール',
                sourceCustomEmpty: '企業カスタムルールの一致データはまだありません',
                searchPlaceholder: '請求項、問題または法条を検索',
                columnIndex: '#',
                columnLocation: '具体的な位置',
                columnIssue: '検査結果/問題',
                columnStatute: '適用法条/ルール根拠',
                columnSuggestion: '修正案',
                columnEvidence: '根拠',
                evidenceEmpty: '—',
                statusPending: '修正が必要',
                statusApplied: '修正済み',
                statusIgnored: '無視済み',
                statusPass: '合格',
                coverageColumnType: 'ルールタイプ',
                coverageColumnRule: 'チェックルール',
                coverageColumnContent: 'ルール内容',
                coverageColumnResult: '検査結果',
                coverageResultEmpty: '—',
                coverageResultFound: '問題が見つかりました',
                ruleTypeOfficial: '公式ルール',
                ruleTypeCustom: '企業ルール',
                itemUnit: '件',
                columnPatentChapter: '特許章節',
                columnCheckRule: 'チェックルール',
                columnCheckResult: '検査結果',
                columnErrorReason: 'エラー理由',
                editButton: '編集',
                adoptButton: '修正を採用',
                locateButton: 'エラー位置の特定',
                locationModalTitle: 'エラー位置',
                locationModalContent: '位置情報：{location}',
                locationModalClose: '閉じる',
                locationModalRuleLabel: 'チェックルール',
                locationModalLocationLabel: '位置',
                locationModalSuggestionLabel: '修正内容',
                locationModalBoundaryLabel: '適用範囲',
                locationModalSourceTitle: 'ソース内容',
                locationModalPositionUnresolved: 'エラー位置を特定できません',
                statusRequireModify: '修正が必要',
                statusRequireConfirm: '人工確認が必要',
                statusPendingVerification: '要再検証',
            },
            finalizing: {
                reportTitle: '特許審査報告書',
                reportSubtitle: '自適応多段ダンピングバッファー装置',
                conclusion: '総合結論',
                totalRules: 'ルール総数',
                passCount: '合格',
                warningCount: '警告',
                errorCount: 'エラー',
                criticalCount: '重大エラー',
                conclusions: {
                    formal: '形式審査の結論',
                    art26_3: '第26条第3項の結論',
                    art26_4: '第26条第4項の結論',
                },
                riskMatrix: {
                    title: '実体審査リスクレベル分布',
                    high: '高リスク',
                    medium: '中リスク',
                    low: '低リスク',
                },
                conclusionValue: {
                    compliant: '適合',
                    risky: '基本的に適合だがリスクあり',
                    non_compliant: '不適合の可能性あり',
                    insufficient: '資料不足のため判断不可',
                },
                dimensionConclusions: {
                    title: '検査項目の結論',
                    unresolved: '未判定',
                },
                reportMeta: {
                    office: '特許庁',
                    applicationType: '出願タイプ',
                    invention: '発明',
                    reportDate: '報告書日付',
                    summaryTitle: '報告書概要',
                    summaryDefault: '明確な形式上の問題を優先的に修正し、引用の達成可能性を確認します。保護範囲と開示根拠を確認します。追加された制限事項の影響を評価し、修正と資料確認の後、再度審査します。',
                    checkModule: 'チェック項目',
                    currentConclusion: '現在の結論',
                    coverageScope: 'カバレッジ範囲',
                    formalCheck: '形式審査',
                    substantiveCheck: '実質審査',
                },
                formalCheckDetail: {
                    title: '形式的問題の詳細',
                    ruleSource: 'ルールソース',
                    ruleCount: 'ルール数',
                    failed: '不合格',
                    needConfirm: '要確認',
                    passed: '合格',
                    pending: '要再検証',
                    systemRules: 'システムルール',
                    customRules: 'カスタムルール',
                    note1: '下の表は検出結果を示します。その他のルールは保留状態に留まります。要確認および保留中の項目は合格を意味しません。',
                    note2: 'ソーステキストは修正用にマークするか、直接修正せずに「todo」としてマークする必要があります。',
                    location: 'ソーステキストと位置',
                    conclusion: '結論とリスク',
                    suggestion: '修正案と境界',
                },
            },
            featureMapping: {
                figuresNone: '本願に図面は含まれていません',
                figuresFailed: '図面認識が完了しなかったため、本判断に図面内容は反映されていません',
                figureNoLabel: '図{no}',
                figureNoUnknown: '図番号が付されていません',
                figureConfidenceMedium: '図番号は推定値です',
                figureConfidenceLow: '図番号を特定できません',
                figureSignsLabel: '符号',
                figureNoSigns: '符号は確認できません',
            },
            substantive: {
                filterHigh: '高リスク',
                filterMedium: '中リスク',
                filterLow: '低リスク',
                filterAll: 'すべて',
                needsInventorConfirm: '発明者による確認が必要',
                boundaryLabel: '適用範囲',
                summaryPattern: '実体的な問題を {count} 件検出しました。各項目を確認してください',
                issuesLocations: '形式問題定位',
                title: '実質審査',
                checkResultTitle: '検査結果',
                issuesCount: '実質問題',
                highRiskCount: '高リスク問題',
            },
            supplement: {
                title: '必要な補充資料一覧',
                columns: {
                    content: '補充すべき内容',
                    reason: '理由',
                    targetStatute: '対象となる法条の問題',
                    suggestedLocation: '推奨される補充箇所',
                },
                empty: '必要な補充資料はありません',
            },
            failed: {
                retryHint: '審査タスクが失敗しました。一覧に戻って再アップロードしてください',
            },
            reportLoadFailed: {
                message: '審査レポートの読み込みに失敗しました。再試行してください',
                retry: '再読み込み',
            },
            stepRunning: 'このステップは実行中です。完了後に結果が表示されます…',
            noStepSelected: 'ステップを選択すると詳細が表示されます',
        },
        customRuleDocuments: {
            delete: '削除',
            edit: '編集',
            deleteConfirm: '削除しますか？',
            confirmYes: '確認',
            confirmNo: 'キャンセル',
            empty: 'ルールドキュメントはまだありません',
            applicableScopeLabelText: '適用範囲',
            sourceLabel: 'ルールソース',
            table: {
                name: 'ライブラリ名',
                office: '地域',
                field: '技術分野',
                rulesCount: 'ルール数',
                updatedAt: '最終更新',
                actions: '操作',
                enabled: '有効',
            },
            rulesEmpty: 'このドキュメントからルールは抽出されませんでした',
            rulesLoadFailed: 'ルール詳細の読み込みに失敗しました。再試行してください',
            rulesCount: '{count} 件のルール',
            status: {
                uploaded: 'アップロード済み',
                parsing: '解析中',
                parsed: '解析済み',
                parse_failed: '解析失敗',
            },
            upload: {
                title: 'ルールドキュメントをアップロード',
                addButton: 'ルールドキュメントをアップロード',
                fileTitle: 'ルールドキュメントをアップロード',
                fileHint: 'PDF、DOCX',
                chooseFile: 'ファイルを選択',
                removeFile: '削除',
                confirm: 'アップロード',
                uploading: 'アップロード中…',
                nameLabel: 'ライブラリ名',
                namePlaceholder: '未入力の場合はファイル名を使用',
                patentOfficeLabel: '地域',
                technicalFieldLabel: '技術分野',
            },
            technicalFieldOptions: {
                Common: '共通',
                Mechanical: '機械',
                Electrical: '電気',
                Chemical: '化学',
            },
            loadFailed: 'ルールドキュメントの読み込みに失敗しました。再試行してください',
            uploadFailed: 'ルールドキュメントのアップロードに失敗しました。再試行してください',
            updateFailed: '更新に失敗しました。再試行してください',
            deleteSuccess: '削除に成功しました',
            deleteFailed: '削除に失敗しました。再試行してください',
            editDrawer: {
                title: 'ルールライブラリを編集',
                save: '保存',
                saving: '保存中…',
                backToList: 'リストに戻る',
            },
            detail: {
                loadFailed: 'ルールライブラリの読み込みに失敗しました。再試行してください',
            },
            import: 'ファイルをインポート',
            importSuccess: 'ファイルのインポートに成功しました。ルールを解析中…',
            importFailed: 'ファイルのインポートに失敗しました。再試行してください',
            parseCompleted: 'ルールの解析が完了しました',
            parseTimeout: 'ルールを解析中です。しばらくしてから手動で更新してください',
            parseFailed: 'ルール解析に失敗しました',
            parseError: 'サポートされていないファイル形式です',
            selectedLabel: '{count} 個のルール ライブラリを選択 · {rules} 件のルール',
        },
        customRule: {
            addRule: 'ルールを追加',
            addFromTemplate: 'テンプレートから追加',
            editRule: 'ルールを編集',
            editRuleDescription: 'チェック条件を詳しく記入して、ルールが正しく実行されるようにしてください。',
            enabled: '有効',
            allRules: 'すべてのルール',
            patentSection: '特許セクション',
            patentSectionPlaceholder: '特許セクションを選択してください',
            patentSectionTitle: '発明の名称',
            patentSectionField: '技術分野',
            patentSectionBackground: '背景',
            patentSectionSummary: '発明の内容',
            patentSectionClaims: '特許請求の範囲',
            patentSectionSpecification: '明細書および図面',
            patentSectionImplementation: '具体的な実施形態',
            patentSectionAbstract: '要約',
            patentSectionSpecificationOnly: '明細書',
            patentSectionFullText: '全文',
            problemDescription: '問題の説明',
            problemDescriptionPlaceholder: '問題の説明を入力してください',
            problemDescriptionTip: '記入方法のヒント: チェック対象を明確にし、トリガー条件を説明してください。「表現が不適切」のように表記するだけでなく。',
            alertType: 'アラートタイプ',
            severityInfo: '情報',
            severityWarning: '警告',
            severityError: 'エラー',
            problemDescriptionRequired: '問題の説明は必須です',
            problemDescriptionMinLength: '問題の説明は10文字以上で入力してください',
            addRuleDialog: {
                title: 'ルールを追加',
                subtitle: 'テンプレートまたは既存ファイルから追加します。既存のルールは保持されます。',
                templateOption: 'ルールテンプレートを使用',
                templateOptionHint: 'よく使うチェックリストから開始',
                importOption: '既存ファイルをインポート',
                importOptionHint: 'Word / Excel / PDF / PPT',
                chooseTemplate: 'ルールテンプレートを選択',
                chooseTemplateHint: 'レビュー基準に近いテンプレートを選び、後で個別に編集できます。',
                templateCount: '{count} 件のテンプレート',
                ruleCount: '{count} 件のルール',
                coveredSections: '対象項目：',
                importFileTitle: 'ルールファイルをアップロード',
                importFileHint: 'Word、Excel、PDF、PPT',
                chooseFile: 'ファイルを選択',
                removeFile: '削除',
                confirm: '保存',
                submitting: '追加中…',
            },
        },
        customRuleLibraries: {
            custom: 'カスタムルール',
            title: 'ルールライブラリ',
            newLibrary: '+ ライブラリを追加',
            total: '{count} 個のルールライブラリ',
            previous: '前へ',
            next: '次へ',
            selectPlaceholder: '選択してください',
            clearFilters: 'フィルターをクリア',
            searchPlaceholder: 'ライブラリ名を検索',
            gridView: 'グリッド表示',
            listView: 'リスト表示',
            all: 'すべて',
            domains: {
                Common: '共通',
                Mechanical: '機械',
                Electrical: '電気',
                Chemical: '化学',
            },
            patentOffice: '受理官庁',
            system: 'システム',
            systemLibraryName: '{office} システムルールライブラリ',
            createDialogTitle: 'ルールライブラリを追加',
            ruleNameLabel: 'ライブラリ名',
            ruleNamePlaceholder: 'ライブラリ名を入力',
            domainLabel: '技術分野',
            create: '作成',
            createSuccess: 'ルールライブラリを作成しました',
            createFailed: '作成に失敗しました。再試行してください',
            editDialogTitle: 'ルールライブラリを編集',
            noRules: 'カスタムルールライブラリはまだありません',
            noRulesDesc: '「ライブラリを追加」をクリックして最初のルールライブラリを作成してください',
        },
        catalog: {
            offices: {
                CNIPA: 'CNIPA',
                EPO: 'EPO',
                USPTO: 'USPTO',
                PCT: 'PCT',
            },
            enabled: '有効',
            loading: '読み込み中...',
            error: '読み込みに失敗しました',
            retry: '再試行',
            empty: 'データなし',
            formalRules: '形式規則',
            substantiveDimensions: '実質的な側面',
            executionPass: 'チェック合格',
            executionTriggered: '問題を検出',
            suggestionLabel: '提案',
            visionUnsupported: 'このルールは図面解析結果に依存するため、単独では実行できません',
            noDocumentSelected: 'まずドキュメントを選択してください',
            executeCheckFailed: 'チェックの実行に失敗しました。再試行してください',
            table: {
                ruleId: 'ルールID',
                category: 'カテゴリー',
                severity: '重大度',
                keyPoint: '要点',
                patentSection: '特許条項',
                guidelineSource: 'ガイドラインソース',
                dimensionId: 'ディメンションID',
                statute: '法令',
                issueType: '問題タイプ',
            },
        },
        errors: {
            createTaskFailed: '審査タスクの作成に失敗しました。再試行してください',
            loadTaskFailed: 'タスク状態の読み込みに失敗しました。再試行してください',
            loadReportFailed: '審査レポートの読み込みに失敗しました。再試行してください',
            loadTasksFailed: 'タスク一覧の読み込みに失敗しました。再試行してください',
            unsupportedOffice: '現在この特許庁はサポートされていません',
            exportReportFailed: '審査レポートの出力に失敗しました。再試行してください',
        },
    },
};
